import helpers from './helpers.js';

export default (function () {
  return {
    init() {
      if (document.querySelectorAll('.ie9').length) return;
      
      const tooltips = document.querySelectorAll('[data-component="js-tooltip"]');

      [...tooltips].forEach((tooltip) => {
        const closebtn = tooltip.querySelector('[data-component="js-tooltip-close"]');

        tooltip.addEventListener('click', (e) => {
          this.handleTooltipToggle(tooltip);
        });
        tooltip.addEventListener('mouseover', (e) => {
          this.handleTooltipOpen(tooltip);
        });
        tooltip.addEventListener('mouseout', (e) => {
          this.handleTooltipClosed(tooltip);
        });
        closebtn.addEventListener('mouseout', (e) => {
          this.handleTooltipClosed(tooltip);
        });
      });
    },
    toggleAttributes(tooltip) {
      const el = tooltip.querySelector('.tooltip__popout');
      if (tooltip.classList.contains('is-open')) {
        el.setAttribute('visibility', 'visible');
      } else {
        el.setAttribute('visibility', 'hidden');
      }
    },
    handleTooltipToggle(tooltip) {
      helpers.toggleClass(tooltip, 'is-open');
      this.toggleAttributes(tooltip);
    },
    handleTooltipClosed(tooltip) {
      helpers.removeClass(tooltip, 'is-open');
      this.toggleAttributes(tooltip);
    },
    handleTooltipOpen(tooltip) {
      helpers.addClass(tooltip, 'is-open');
      this.toggleAttributes(tooltip);
    },
  };
}());
